<template>
  <div class="d-flex">
    <v-img :src="imageUrl" max-height="200" max-width="130" class="mr-5 mr-md-10 w-130" />
    <div class="border-bottom">
      <h3 class="comment"><slot></slot></h3>
      <h2 class="pretopia-head-font"><slot name="name"></slot></h2>
      <p>
        <slot name="title"></slot>, 
        <span class="font-weight-medium">
          <slot name="company"></slot>
        </span>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    image: {
      type: String,
      required: true
    }
  },
  computed: {
    imageUrl: function() {
      return 'images/customercomment/' + this.image;
    }
  }
}
</script>

<style scoped>
.comment {
  font-style: italic;
  font-weight: normal;
}
.w-130 {
  width: 130px;
}
</style>